export const BBL_FETCH_REQUESTED = 'BBL_FETCH_REQUESTED'
export const BBL_FETCH_SUCCESS = 'BBL_FETCH_SUCCESS'
export const BBL_FETCH_FAILED = 'BBL_FETCH_FAILED'
